import { FC, ReactElement } from 'react';

import { AnchorTargetInterface } from '../../../entities/@blocks/AnchorTarget/AnchorTarget';

interface AnchorTargetProps extends AnchorTargetInterface {
    className?: string;
}

export const AnchorTarget: FC<AnchorTargetProps> = ({
    anchorId,
    className = '',
}): ReactElement => (
    <div
        id={anchorId}
        className={`anchor-target ${className}`}
    />
);
